import React, { Component } from 'react';
import axios from 'axios';
import { authService } from '../../../utils/auth-service';

const withInfluencerData = WrapperComponent => class HasJSONAPIClient extends Component {
  constructor(props) {
    super(props);
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 6000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  getInfluencerById= id => this.restClient.get(`influencer/${id}`)
    .then(response => {
      const { data: { data: { id: influencerId, attributes } } } = response;
      return { id: influencerId, ...attributes };
    });

  render() {
    return (
      <WrapperComponent
        {...this.props}
        getInfluencerById={this.getInfluencerById}
      />
    );
  }
};

export default withInfluencerData;



/** WEBPACK FOOTER **
 ** ./src/hocs/data/with-influencer-data/index.js
 **/